import React, { useEffect } from "react";
import DateConverter from "@heartinz/date_and_time_processor";
import { useAuth } from "../../../context/AuthProvider";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import { CloseIcon } from "../../../constants/Icons";

const AdvanceHistoryModal = ({ history, onClose }) => {
  const { isUser } = useAuth();
  return (
    <>
      <div className="modal-backdrop show"></div>
      <div
        className="modal show"
        tabIndex="-1"
        role="dialog"
        style={{ display: "block" }}
      >
        <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Advance Payment History</h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
              ></button>
            </div>
            <div className="modal-body bg-light">
              {history.length === 0 ? (
                <p className="text-muted">No advance payments yet.</p>
              ) : (
                <div className="row g-3">
                  {history.map((entry, idx) => (
                    <div key={entry._id || idx} className="col-12">
                      <div className="card shadow-sm">
                        <div className="card-body">
                          <div className="d-flex justify-content-between align-items-start mb-2">
                            <h6 className="card-title mb-0">{entry.title}</h6>
                            <span className="badge rounded-pill bg-label-fall text-right">
                              Amount: ₹{" "}
                              {CurrencyConverter.toCurrency(
                                entry.amount || 0,
                                "INR"
                              )}
                            </span>
                          </div>
                          <div className=" mb-1">
                            <strong>Description:</strong> {entry.description}
                          </div>
                          <div className=" mb-1">
                            <strong>Amount in Words:</strong>{" "}
                            {entry.amountInWords}
                          </div>
                          <div className=" mb-1">
                            <strong className="">Date of Issue: </strong>
                            {
                              DateConverter.ISOToDisplayFormat(
                                DateConverter.convertToTimeZone(
                                  entry?.dateOfIssue,
                                  isUser?.timezone
                                )
                              ).date
                            }
                          </div>
                          {/* <p className="card-text mb-1">
                            <strong>Voucher Number:</strong>{" "}
                            {entry.voucherNumber}
                          </p> */}
                          <div className="text-right small mb-0">
                            <b className="tm_primary_color">Created At : </b>
                            {
                              DateConverter.ISOToDisplayFormat(
                                DateConverter.convertToTimeZone(
                                  entry?.createdAt,
                                  isUser?.timezone
                                )
                              ).date
                            }{" "}
                            {
                              DateConverter.ISOToDisplayFormat(
                                DateConverter.convertToTimeZone(
                                  entry?.createdAt,
                                  isUser?.timezone
                                )
                              ).time
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div className="modal-footer d-block">
              <button
                className="btn btn-outline-secondary text-left"
                onClick={onClose}
              >
                <CloseIcon iClass={"fs-15"}/> Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdvanceHistoryModal;
